/**
 * move blogs into wrapper
 */
(() => {
  const blogWrapper = document.querySelector('.js-services-blog .splide__list');
  const blogContainer = document.querySelector('.resources-articles-blog');
  if (!blogWrapper || !blogContainer) return;

  blogContainer.querySelectorAll('.splide__slide.services-slide')
    .forEach((blog) => {
      blogWrapper.appendChild(blog);
    });
})();
